export const getUniqueElemensById = (entities) => {
    return entities.filter((entity, index, self) => self.findIndex(e => e.id === entity.id) === index);
};
//# sourceMappingURL=getUniqueElemensById.js.map